<template>
  <div class="field mb-2 sm:mb-0">
    <div v-if="field.type === 'select' && !loadingOptions" class="dropdown">
      <multiselect
        :value="field.selectedOption"
        @input="(selectedOption) => onFieldChange(selectedOption)"
        :options="options"
        :showLabels="false"
        :hideSelected="false"
        :placeholder="$t(field.placeHolder) || field.placeHolder"
        :disabled="isDisabled"
        :key="`${reportType}-${field.dropdownOptionsType || 'default'}-${options.length}-${field.selectedOption ? field.selectedOption.id : 'none'}`"
        trackBy='id'
        label='name'
      />
    </div>
    <div v-if="field.type === 'text'" class="label">
      <p>{{ $t(field.value) || field.value }}</p>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'ReportField',
  components: {
    Multiselect,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    reportType: {
      type: Number,
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    loadingOptions: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onFieldChange(selectedOption) {
      this.$emit('field-change', this.field, selectedOption);
      // Force update to ensure the multiselect displays the selection
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
  },
};
</script>

<style lang="scss">
.field {
  width: 100%;
}

.dropdown {
  width: 100%;

  .multiselect__tags,
  .multiselect__input,
  .multiselect__single {
    background-color: #d9dbdb;
  }

  .multiselect__placeholder,
  .multiselect__single {
    font-size: 12px;
  }
}

.label {
  font-size: 12px;
}
</style>
